import { Typography } from '@remarkable/ark-web';

import { Feedback } from 'src/components';
import { AppPage } from 'src/components/AppPage';

import { Trans, useLingui } from '@lingui/react/macro';
import { CheckoutForm } from '../components/CheckoutForm';

export const ConnectCheckoutPage = () => {
  const { t } = useLingui();
  return (
    <AppPage.Container>
      <div className="m-auto my-32 max-w-lm px-16 text-center ll:mt-64 ll:mb-80">
        <Typography className="mb-24" variant="responsive-heading-lg">
          <Trans>Subscribe to Connect</Trans>
        </Typography>

        <Typography variant="responsive-body-md" className="my-0">
          <Trans>
            You&apos;re one step away from starting your subscription.
          </Trans>
        </Typography>
      </div>

      <AppPage.Content className="max-w-l2xl">
        <CheckoutForm />
        <Feedback
          className="mt-320 mb-32"
          title={t`Did you find what you were looking for?`}
          feedbackTargetId="store-connect-checkout"
        />
      </AppPage.Content>
    </AppPage.Container>
  );
};
